import { App } from "./app";
import { AppError } from "./app-error";
import { Environment, TLD, URLs } from "shared";
import { parseDataIsland } from "./utils/parseDataIsland";
import * as Sentry from "@sentry/react";
import { routes } from "./routing/routes";

type SuccessOrErrorComponentProps = {
  tld: TLD;
  urls: URLs;
  environment: Environment;
  accountDataElement: HTMLElement | null;
};

export const SuccessOrErrorComponent = ({
  tld,
  urls,
  environment,
  accountDataElement,
}: SuccessOrErrorComponentProps) => {
  const dataIsland = parseDataIsland(accountDataElement);
  const { logoutId } = dataIsland;

  const error =
    dataIsland.status === "error" ? dataIsland.error : "An error has occurred";
  const appError = (
    <AppError urls={urls} error={error} logoutUrl={routes.logout(logoutId)} />
  );

  return dataIsland.status === "success" ? (
    <Sentry.ErrorBoundary fallback={appError}>
      <App
        urls={urls}
        tld={tld}
        environment={environment}
        customer={dataIsland.customer}
        contactId={dataIsland.contactId}
        featureFlags={dataIsland.featureFlags}
        isStateFarmPartitioned={dataIsland.isStateFarmPartitioned}
        logoutId={logoutId}
        emailHash={dataIsland.emailHash}
        isSso={dataIsland.isSso}
        isEmailVerified={dataIsland.isEmailVerified}
        isMfa={dataIsland.isMfa}
      />
    </Sentry.ErrorBoundary>
  ) : (
    appError
  );
};
